import { Event, EventType } from "../../libs/data/event";
import { EventCompStyle, EventRegisterBtn } from "./event.comp.style";

export const EventComp = (props: { event: Event }) => {
  const { event } = props;
  const isFull = event.capacity === event.rsvp.length;
  const isUponRequest = event.capacity === -1;
  const isSchedule =
    event.type === EventType.Schedule || event.tags?.includes("schedule");
  const hasImage = !!event.image;

  return (
    <EventCompStyle
      key={event.id}
      className={`${isFull ? "full" : ""} ${
        event.boxColour ? "has-colour" : ""
      } ${event.boxBorder ? "has-promo" : ""} ${
        isUponRequest ? "upon-request" : ""
      } ${hasImage ? "with-image" : ""}`}
      style={{
        backgroundColor: event.boxColour,
        border: event.boxBorder ? `solid 6px ${event.boxBorder}` : "none",
      }}
    >
      {event.image && <img className="event-img" src={event.image} />}

      <p className="event-name">{event.name}</p>
      {isSchedule ? (
        <p className="event-date">
          {event.startTime} - {event.endTime}
        </p>
      ) : (
        <p className="event-date">
          {event.startDate
            ?.toDateString()
            .replace(`${event.startDate.getFullYear()}`, "")}
          {event.endDate && ` - ${event.endDate?.toDateString()}`}
          <br />
          {event.startTime} - {event.endTime}
        </p>
      )}

      <p className="event-description">
        <strong>{event.description}</strong>
      </p>
      {!isSchedule && (
        <p className="event-description">{event.price ? event.price : ""}</p>
      )}

      {isFull ? (
        <p>
          <strong>FULL</strong>
        </p>
      ) : isUponRequest ? (
        <p>
          <strong>Contact to Register</strong>
        </p>
      ) : event.comingSoon ? (
        <p>
          <strong>Coming Soon!</strong>
        </p>
      ) : (
        <>
          {event.noRegistration ? null : (
            <a
              href={`/${event.payment ? "register" : "preregister"}/${
                event.id
              }`}
              target="_blank"
            >
              <EventRegisterBtn
                className={`${event.boxColour ? "hasColour" : ""} register-btn`}
              >
                Learn more
              </EventRegisterBtn>
            </a>
          )}
        </>
      )}
    </EventCompStyle>
  );
};
